import { CartTicketItemModel } from "./cart-ticket-item.model";

export class CartScreeningModel {
  public screeningId: string;
  public items: Array<CartTicketItemModel> = new Array<CartTicketItemModel>();
}
